import { Pagination } from "@/components/pagination/pagination";
import { ServerPaginationState } from "../types";

export interface DataListPaginationProps {
  paginationState: ServerPaginationState;
  totalItems: number;
  onPaginationChange: (state: ServerPaginationState) => void;
  isLoading?: boolean;
}

export function DataListPagination({
  paginationState,
  totalItems,
  onPaginationChange,
  isLoading,
}: DataListPaginationProps) {
  const currentPage = paginationState.page;
  const totalPages = Math.max(Math.ceil(totalItems / paginationState.pageSize), 1);

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      onPaginationChange({ ...paginationState, page });
    }
  };

  return (
    <Pagination
      currentPage={currentPage}
      lastPage={totalPages}
      canGoPrevious={currentPage > 1}
      canGoNext={currentPage < totalPages}
      onFirstPage={() => handlePageChange(1)}
      onPreviousPage={() => handlePageChange(currentPage - 1)}
      onNextPage={() => handlePageChange(currentPage + 1)}
      onLastPage={() => handlePageChange(totalPages)}
      onGoToPage={handlePageChange}
      isLoading={isLoading}
    />
  );
}
